/**
 * @file Form送信
 */
'use strict';
import Common from '../util/_common';

/**
 * @classname FormDatePickerView
 * @classdesc DatePicker
 */
export default class FormDatePickerView {

	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {controller} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log('FormDatePickerView.constructor');
		this._$e = $e;
		this._$inputGroup = $e.parent('.input-group');
		this._controller = controller;
		const shopId = $e.attr('data-shop-id');
		const xmasFlg = $e.attr('data-xmas');
		this._controller.getAvailableDate(shopId, xmasFlg);
		this._controller.on('onGetAvailableDateComplete', () => this.getAvailableDateComplete());
		this._weeks = ['日', '月', '火', '水', '木', '金', '土'];
	};


	/**
	 * 受け取り可能日取得のコールバック
	 *
	 * @memberof FormDatePickerView
	 * @return {undefined}
	 */
	getAvailableDateComplete() {
		console.log('FormDatePickerView.getAvailableDateComplete');
		this._data = this._controller._data;
		console.log(this._data);
		let cDate = [];
		if(this._data.length > 0) {
			const firstDay = this._data[0].split('-');
			const firstYear = firstDay[0];
			const firstMonth = firstDay[1];
			const lastDay = this._data[this._data.length - 1].split('-');
			const lastYear = lastDay[0];
			const lastMonth = lastDay[1];
			console.log(`${lastYear}/${lastMonth}`);
			let calendar = this.createCalendar(firstYear, firstMonth);
			if($('#calendar')[0]) {
				console.log('has calendar');
			} else {
				console.log('not has calendar');
				this._$inputGroup.append(calendar);
				// 受け取り可能日の最初と最後が一緒の月の場合は次の月のボタンも押せなくする
			}
		} else {
			Common.showErrorModal('受取可能日がありません');
			return;
		}
		this._$e.closest('.input-group').on('click', () => this.onClick());
		this.setCalendar();
	};

	/**
	 * 日付選択イベントの登録
	 *
	 * @memberof FormDatePickerView
	 * @return {undefined}
	 */
	setCalendar() {
		console.log(`FormDatePickerView.setCalendar`);
		const firstDay = this._data[0].split('-');
		const firstYear = firstDay[0];
		const firstMonth = firstDay[1];
		const firstYearMonth = `${firstYear}${firstMonth}`;
		const lastDay = this._data[this._data.length - 1].split('-');
		const lastYear = lastDay[0];
		const lastMonth = lastDay[1];
		const lastYearMonth = `${lastYear}${lastMonth}`;
		let cDate = this.getCalendarYearMonth();
		const currentYearMonth = `${cDate[0]}${cDate[1]}`;
		console.log(firstYearMonth, lastYearMonth, currentYearMonth);

		// 前月、次月ボタン
		const $btnPrev = $('.calendar-button-prev');
		const $btnNext = $('.calendar-button-next');
		if(firstYearMonth === lastYearMonth) {
			$btnPrev.addClass('disabled');
			$btnNext.addClass('disabled');
		} else {
			if (firstYearMonth === currentYearMonth) {
				$btnPrev.addClass('disabled')
			}
			if (lastYearMonth === currentYearMonth) {
				$btnNext.addClass('disabled')
			}
		}
		// 受取日以外を選択不可能にする
		$('.anchor-calendar-date').each((idx, e) => {
			const $e = $(e);
			const cDay = $e.text();
			let flg = false;
			for(let i = 0; i < this._data.length; i++) {
				let dateArr = this._data[i].split('-');
				if(dateArr[0] === cDate[0] && dateArr[1] === Common.zeroPadding(cDate[1], 2) && dateArr[2] === Common.zeroPadding(cDay, 2)) {
					flg = true;
				}
			}
			if(!flg) $e.parent('.calendar_td').addClass('is-disabled').html(cDay);
		})
		this.setCalendarEvent();
	}


	/**
	 * 現在のカレンダー年月を取得する
	 *
	 * @memberof FormDatePickerView
	 * @return {undefined}
	 */
	setCalendarEvent() {
		console.log(`FormDatePickerView.setCalendarEvent`);
		$('#calendar').on('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
		})

		// 日付決定
		$('.anchor-calendar-date').on('click', (e) => {
			this.selectDate(e);
		})

		let cDate = this.getCalendarYearMonth();
		let year = parseInt(cDate[0]);
		let month = parseInt(cDate[1]);

		// 前月ボタンクリック
		$('.calendar-button-prev').on('click', () => {
			console.log('click prev month')
			month = month - 1;
			if(month <= 0) {
				month = 12;
				year --;
			}
			console.log(year, month);
			let calendar = this.createCalendar(year, month, true);
			$('#calendar').html(calendar);
			this.setCalendar();
		})
		// 次月ボタンクリック
		$('.calendar-button-next').on('click', () => {
			console.log('click next month')
			cDate = this.getCalendarYearMonth();
			let year = parseInt(cDate[0]);
			let month = parseInt(cDate[1]);
			month = month + 1;
			if(month >= 13) {
				month = 1;
				year ++;
			}
			console.log(year, month);
			let calendar = this.createCalendar(year, month, true);
			$('#calendar').html(calendar);
			this.setCalendar();
		})

	}


	/**
	 * 現在のカレンダー年月を取得する
	 *
	 * @memberof FormDatePickerView
	 * @return {undefined}
	 */
	getCalendarYearMonth() {
		console.log(`FormDatePickerView.getCalendarYearMonth`);
		const $title = $('.text-calendar-title');
		let cYear = $title.attr('data-year');
		let cMonth = Common.zeroPadding($title.attr('data-month'), 2);
		return [cYear, cMonth];
	}



	/**
	 * カレンダーを作成する
	 *
	 * @memberof FormDatePickerView
	 * @param {string} year - 年
	 * @param {string} month - 月
	 * @param {boolean} show - 表示するかどうかのフラグ
	 * @return {undefined}
	 */
	createCalendar(year, month, show = false) {
		console.log(`FormDatePickerView.createCalendar ${year}/${month}`);
		const startDate = new Date(year, month - 1, 1); // 月の最初の日を取得
		const endDate = new Date(year, month,  0); // 月の最後の日を取得
		const endDayCount = endDate.getDate(); // 月の末日
		const lastMonthEndDate = new Date(year, month - 1, 0); // 前月の最後の日の情報
		const lastMonthEndDayCount = lastMonthEndDate.getDate(); // 前月の末日
		const startDay = startDate.getDay(); // 月の最初の日の曜日を取得
		let dayCount = 1; // 日にちのカウント
		let calendarHtml = '';
		if(show) {
			calendarHtml = '';
		} else {
			calendarHtml = '<div id="calendar">';
		}

		calendarHtml += `<div class="calendar-title"><a href="javascript:void(0);" class="calendar-button calendar-button-prev"></a><p class="text text-calendar-title" data-year="${year}" data-month="${Common.zeroPadding(month, 2)}">${year}/${Common.zeroPadding(month, 2)}</p><a href="javascript:void(0);" class="calendar-button calendar-button-next"></a></div>`;
		calendarHtml += '<div class="calendar-wrap"><table class="table-calendar">';

		// 曜日の行を作成
		calendarHtml += '<tr>';
		for (let i = 0; i < this._weeks.length; i++) {
			calendarHtml += '<td>' + this._weeks[i] + '</td>';
		}
		calendarHtml += '</tr>';
		for (let w = 0; w < 6; w++) {
			calendarHtml += '<tr>';
			if(dayCount <= endDayCount) {
				for (let d = 0; d < 7; d++) {
					if (w === 0 && d < startDay){
						// 1行目で1日の曜日の前
						let num = lastMonthEndDayCount - startDay + d + 1;
						calendarHtml += '<td class="is-disabled">' + num + '</td>';
					} else if (dayCount > endDayCount) {
						// 末尾の日数を超えた
						let num = dayCount - endDayCount;
						calendarHtml += '<td class="is-disabled">' + num + '</td>';
						dayCount++;
					} else {
						calendarHtml += `<td class="calendar_td"><a class="anchor anchor-calendar-date" href="javascript:void(0);" data-date="${year}-${Common.zeroPadding(month, 2)}-${Common.zeroPadding(dayCount,2)}">${dayCount}</a></td>`;
						dayCount++;
					}
				}
			}
			calendarHtml += '</tr>';
		}
		calendarHtml += '</table>';
		calendarHtml += '</div>'
		calendarHtml += '<div class="calendar-footer">受取可能な日のみ選択できます</div>'
		if (show) {
			calendarHtml += '</div>';
		}
		return calendarHtml;
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof FormDatePickerView
	 * @return {undefined}
	 */
	onClick() {
		const $calendar = $('#calendar');
		if($calendar.hasClass('show')) {
			$calendar.animate({'top': '70px'}, 200);
			setTimeout(() => $calendar.removeClass('show'), 200);
		} else {
			$calendar.addClass('show');
			$calendar.animate({'top': '50px'}, 200);
		}
	}


	/**
	 * 日付を選択する
	 *
	 * @memberof FormDatePickerView
	 * @param {event} e - イベント
	 * @return {undefined}
	 */
	selectDate(e) {
		const $e = $(e.currentTarget);
		const date = $e.attr('data-date');
		this._$e.val(date);
		const $calendar = $('#calendar');
		$calendar.animate({'top': '70px'}, 200);
		setTimeout(() => $calendar.removeClass('show'), 200);
	}
}
